import { ChatbotConfig, ChatNode } from './chatbot.model';
import { CHATBOT_DATA } from './chatbot-erp.data';

type Seccion = { mensaje: string; opciones: { boton: string; respuesta?: string; llevaA?: string }[] }

function mapearNodo(id: string, seccion: Seccion): ChatNode {
  return {
    id,
    message: seccion.mensaje,
    options: seccion.opciones.map(op => ({
      label: op.boton,
      ...(op.respuesta ? { response: op.respuesta } : {}),
      ...(op.llevaA ? { nextNodeId: op.llevaA } : {})
    }))
  }
}

export const ERP_CHATBOT_CONFIG: ChatbotConfig = {
  botName: CHATBOT_DATA.botName,
  welcomeMessage: CHATBOT_DATA.welcomeMessage,
  contactInfo: CHATBOT_DATA.contactInfo,
  rootNodeId: 'inicio',
  nodes: Object.entries(CHATBOT_DATA.secciones).map(([id, seccion]) => mapearNodo(id, seccion))
}